export default () => (
  <svg aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    height="20"
    width="20"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M1 5h30v22H1z" strokeWidth="2" />
      <path
        d="M7 16a5 5 0 1010 0 5 5 0 10-10 0zM16 18.97a5 5 0 100-5.94"
        strokeWidth="2"
      />
    </g>
  </svg>
);
